import * as Types from 'src/actions/project/comments/get/Types';
import ProjectComment from 'src/entities/ProjectComment';
import {
  GetProjectCommentsAction,
  GetProjectCommentsSuccess
} from 'src/actions/project/comments/get/GetProjectComments.actions';

export interface GetProjectCommentsState {
  comments: ProjectComment[];
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetProjectCommentsState = {
  comments: [],
  loading: false,
  error: false,
  errorMessage: {},
};

export function GetProjectCommentsReducer(state: GetProjectCommentsState = initialState,
                                          action: GetProjectCommentsAction): GetProjectCommentsState {
  switch (action.type) {
    case Types.GET_PROJECT_COMMENTS_ATTEMPT:
      return {...state, loading: true, error: false};
    case Types.GET_PROJECT_COMMENTS_SUCCESS:
      const comments = (action as GetProjectCommentsSuccess).payload;
      return {...state, comments: comments, loading: false, error: false};
    case Types.GET_PROJECT_COMMENTS_FAILURE:
      return {...state, loading: false, error: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/comments/GetProjectCommentsReducer.tsx